
import { component } from '@/helpers/vueTyped';
import Menu from './Menu.vue';
import store, { dispatch } from '@/store';

export default component()({
  name: 'Drawer',

  computed: {
    open(): boolean { return store.state.drawerOpen; },
    hide(): boolean { return store.state.drawerHidden; },
  },

  methods: {
    openDrawer() {
      dispatch('setDrawerOpenState', [true]);
    },
  },

  render() {
    return (
      <div
        onFocusin={this.openDrawer}
        class={[ 'drawer', !this.open && 'drawerClosed', this.hide && 'drawerHidden' ]}
      >
        <Menu />
      </div>
    );
  },
});


// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7ae23686/Drawer.vue" });